import { apiSlice } from '@services/apiSlice';
import { Search as endpoints } from '@services/endpoints';
import { SearchResult } from './SearchPage.types';

interface SearchQueryParams {
  page: number;
  query: string;
  orderBy: string;
  category: string;
}

const searchApi = apiSlice
  .injectEndpoints({
    endpoints: (build) => ({
      doSearch: build.query<SearchResult, SearchQueryParams>({
        query: (params) => ({
          url: endpoints.doSearch,
          params: { lang: window.lang, ...params },
        }),
      }),
      doSearchAutocomplete: build.query<string[], string>({
        query: (searchString) => ({
          url: endpoints.doSearchAutocomplete,
          params: { prefix: searchString }
        }),
      }),
    }),
    overrideExisting: false,
  })

export const { useLazyDoSearchAutocompleteQuery, useDoSearchQuery } = searchApi;